import { ApiProperty } from '@nestjs/swagger';
import { CityTranslationViewModel } from './cityTranslationViewModel';

export class CityView {
  id: number;
  regionId: number;
  alias: string;
  centerPoint?: string;
  translation: CityTranslationViewModel;
  timezone: string;
}

export class CityViewModel {
  @ApiProperty()
  id: number;

  @ApiProperty()
  regionId: number;

  @ApiProperty()
  alias: string;

  @ApiProperty({ required: false })
  centerPoint?: string;

  @ApiProperty()
  translation: CityTranslationViewModel;

  @ApiProperty()
  timezone: string;
}
